import { ReactNode } from 'react';
import styles from './Button.module.scss';
import { ButtonShared, ButtonSharedProps } from './ButtonShared';

interface Props {
  align?: 'start' | 'center' | 'end';
  icon?: ReactNode;
}

type ButtonProps = Props & ButtonSharedProps;

export function Button({ ref, ...props }: ButtonProps) {
  const { size = 'medium', width = 'auto' } = props;

  const className = [
    styles[`button-size-${size}`],
    styles[`button-width-${width}`],
    props.variant === 'text' && styles['button-text'],
  ]
    .filter(Boolean)
    .join(' ');

  const iconClassName = [styles[`button-icon`]].filter(Boolean).join(' ');

  return (
    <ButtonShared ref={ref} className={className} {...props}>
      <span className={iconClassName}>{props.icon}</span>
      <span>{props.children}</span>
    </ButtonShared>
  );
}
